module.exports = __webpack_public_path__ + "static/media/BNCEstates_Logo.0726cdff.png";